import $ from 'jquery';

$(document).ready(() => {
    if($('.boxRefContainer').length) {
        if($(window).width() > 800) {
            let highest = 0;

            $('.boxRefContainer').each((o, l) => {
                if($(l).outerHeight() > highest) {
                    highest = $(l).outerHeight();
                }
            });

            $('.boxRefContainer').css('height', highest + 'px');
        }
    }
});